import { runAction } from "../client";

export interface Timezone
{
    Id: number;
    UtcOffsetMinutes: number;
    Display: string;
}

export interface TimezoneResult
{
    Timezones: Timezone[];
}

export interface GetTimezonesFn
{
    (): Promise<TimezoneResult>;
}

export const getTimezones: GetTimezonesFn = (): Promise<TimezoneResult> => {
    return runAction<TimezoneResult>('/action/GetTimezones', {});
}


// WEBPACK FOOTER //
// ./src/rest/Misc/timezones.ts